module.exports = __webpack_public_path__ + "static/media/no_3.12481978.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Home/components/HomeFavourableRoll/images/no_3.png
// module id = 437
// module chunks = 0